import { api } from './client';
import { AccountsUsageResponse, MyUsageResponse } from '../types/dashboard';

export async function fetchMyUsage(): Promise<MyUsageResponse> {
  const res = await api.get<MyUsageResponse>('/api/dashboard/usage/me');
  return res.data;
}

export async function fetchAccountsUsage(): Promise<AccountsUsageResponse> {
  const res = await api.get<AccountsUsageResponse>('/api/dashboard/usage/accounts', {
    params: { sort: 'turns', order: 'desc', window_days: 7, include_inactive: false },
  });
  return res.data;
}
